module.exports = __webpack_public_path__ + "img/service1.6ef7743a.svg";